

// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./wc2023-feature.css";

// *************************************************** Insert Winter Camp 2023 Feature **************************************************** //

class WC2023Feature extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

<!-- **************************************** BEGIN: WINTER CAMP 2023 ********************************************* -->

  <div class="wc23-container container">
  
    <!-- ************** BEGIN: Title of Section ************** -->

    <div class="row col-lg-12 justify-content-center">

      <span class="col-3 col-md-2 col-lg-1 badge badge-dark-purple text-white mt-4">
        <img src="assets/icons/white-brackets.png" height="30px" alt="html brackets">
      </span>

      <p class="section-title-size serif-heading bold mx-auto text-center mt-2 pb-0 mb-4 text-hot-pink">
        Winter Camp 2023
      </p>

    </div>

    <!-- ************** END: Title of Section ************** -->


    <!-- ************** BEGIN: Split-Screen Flyer & Description ************** -->

    <!-- Changed column configurations from 5/7 to an expanded layout footprint -->

    <div class="row g-4 align-items-stretch mb-5">
      
      <!-- LEFT: Expanded Flyer Graphic Card Area -->

      <div class="col-12 col-lg-5 text-center d-flex align-items-stretch justify-content-center">

        <!-- Added w-100 class handle to allow fluid width tracking inside the parent column -->

        <div class="winter-camp-graphic w-100 p-3 rounded-3 shadow mx-auto d-flex align-items-center justify-content-center">
          <img src="assets/flyers/girls-code-savannah-flyer-wc2023.png" class="img-fluid dynamic-flyer-img" alt="Girls Code Savannah winter camp flyer">
        </div>

      </div>

      <!-- RIGHT: Camp Description Blocks -->

      <div class="col-12 col-lg-7 d-flex">

        <div class="camp-text-card w-100 p-4 rounded-4 shadow-sm bg-white bg-opacity-25 d-flex flex-column justify-content-center">
          
          <p class="text-size-body leading-relaxed mb-3 text-start text-dark-blue">
            Our <a class="text-hot-pink serif-heading text-size-h3 bold text-decoration-none" href="/winter-camp-2023">FREE 2023 Winter Camp</a>
            was held December 18th - 22nd at the Georgia Southern University-Armstrong Campus. It was our largest 
            Girls Code Savannah camp yet with
            <span class="text-hot-pink serif-heading text-size-h3 bold">a record 55 students in 5th - 8th grade 
            attending from across all 8 Savannah Chatham County Public School Districts!</span>
          </p>

          <p class="text-size-body leading-relaxed mb-3 text-start">
            In two Georgia Southern University computer labs, parallel coding classes took place — one for 
            beginner website coders and another for 
            <a class="text-hot-pink serif-heading text-size-h3 bold text-decoration-none mx-1" href="/summer-camp-2023">Summer Camp 2023</a> & 
            <a class="text-hot-pink serif-heading text-size-h3 bold text-decoration-none" href="#fall-2023">Fall 2023 Saturday Sessions</a> returning coders.
          </p>

          <p class="text-size-body leading-relaxed mb-3 text-start">
            The beginner‐level coding lab taught introduction to HTML and CSS for those new to website coding while 
            the second coding lab allowed continuing website coders to build upon their already-created websites 
            and to learn new JavaScript programming skills, making their current websites more dynamic.
          </p>

          <p class="text-size-body leading-relaxed m-0 text-start">
            In addition to building their real-world coding skills throughout the week, 
            campers also engaged with several female guest instructors and speakers who 
            inspired them with interactive sessions and stories of how they are using 
            tech daily to develop their own careers, businesses, and dreams of the future.
          </p>

        </div>

      </div>

    </div>

    <!-- ************** END: Split-Screen Flyer & Description ************** -->


    <!-- *************** BEGIN: Invited Guest Instructors & Speakers ************ -->
    
    <div class="row g-4 justify-content-center mt-5 mb-4">
    
      <!-- Guest 1 -->

      <div class="col-12 col-sm-6 col-md-4 col-lg-3 text-center">

        <div class="guest-card p-3 rounded-4 shadow-sm bg-white h-100 d-flex flex-column align-items-center">

          <div class="headshot-wrapper mb-3">
            <img class="img-fluid headshot-img" src="assets/headshots/jessie-may-headshot.jpg" alt="Jessie May Wolf, Founder of the HeartRise Method">
          </div>

          <a class="text-hot-pink serif-heading text-size-h3 bold text-decoration-none mb-1 d-block" href="https://linkedin.com" target="_blank">Jessie May Wolfe</a>
          
          <p class="text-dark-blue mb-1">Creative + Entrepreneur</p>
          
          <p class="text-dark-blue mb-0">Founder, <a class="text-hot-pink serif-heading text-size-h4 bold text-decoration-none" href="https://heartrisemovement.com" target="_blank">HeartRise Movement</a></p>
        
        </div>
      
      </div>

      <!-- Guest 2 -->

      <div class="col-12 col-sm-6 col-md-4 col-lg-3 text-center">

        <div class="guest-card p-3 rounded-4 shadow-sm bg-white h-100 d-flex flex-column align-items-center">

          <div class="headshot-wrapper mb-3">
            <img class="img-fluid headshot-img" src="assets/headshots/daniette-headshot.jpg" alt="Danietté Thomas, CEO of DANIETTÉ Custom Couture">
          </div>

          <a class="text-hot-pink serif-heading text-size-h3 bold text-decoration-none mb-1 d-block" href="https://linkedin.com" target="_blank">Danietté Thomas</a>
          
          <p class="text-dark-blue mb-1">Fashion Designer</p>
         
          <p class="text-dark-blue mb-0">CEO, <a class="text-hot-pink serif-heading text-size-h4 bold text-decoration-none" href="https://arionnacollection.com" target="_blank">ARIONNA Collection</a></p>
        
        </div>

      </div>

      <!-- Guest 3 -->

      <div class="col-12 col-sm-6 col-md-4 col-lg-3 text-center">

        <div class="guest-card p-3 rounded-4 shadow-sm bg-white h-100 d-flex flex-column align-items-center justify-content-center">
          
          <div class="headshot-wrapper mb-3">
            <img class="img-fluid headshot-img" src="assets/headshots/melanie-headshot.png" alt="Melanie DeFilippis, CEO of Leto Maternal Health">
          </div>
          
          <h4 class="text-hot-pink serif-heading text-size-h3 bold mb-1 melanie">Melanie DeFilippis</h4>
          
          <p class="text-dark-blue mb-1">Tech Startup Founder</p>
          
          <p class="text-dark-blue mb-0">CEO, Leto Maternal Health</p>
        
        </div>
      
      </div>

    </div>

    <!-- Showcase Summary Paragraph -->

    <div class="col-12 col-lg-10 my-4 text-center mx-auto">

      <div class="showcase-summary p-3 rounded-3 text-start">

        <p class="text-size-body leading-relaxed m-0">
          Camp ended with a giant pizza party and Camp Showcase where campers showed off their new and 
          expanded websites to Savannah community leaders, the local media, family, and friends.
        </p>

      </div>

    </div>

    <!-- *************** END: Invited Guest Instructors & Speakers ************ -->


      
    <!-- ************* BEGIN: Winter Camp Button *********** -->

    <div class="button text-center my-3">

      <a href="/winter-camp-2023" class="text-decoration-none">
        <button type="button" class="hero-button-1 btn bg-hot-pink text-white px-3 py-3 fw-bold rounded-pill shadow">CHECK OUT WINTER CAMP 2023</button>
      </a>

    </div>

    <!-- ************* END: Winter Camp Button *********** -->



  <!-- ************* BEGIN: Winter Camp 2023 Sponsors *********** -->

  <div class="col-12 text-center mx-auto mt-3">     

    <div class="d-flex justify-content-center mb-4">

      <p class="serif-heading bold mx-auto text-center m-2 text-size-secondary-heading text-hot-pink">
        Thank You to Our Winter Camp 2023 Sponsors & Supporters!
      </p>

    </div>

    <!-- Sponsor Logo Section Grid -->

    <div class="row g-3 justify-content-center align-items-center text-center mb-4">

      <!-- 1. City of Savannah -->
      <div class="col-6 col-sm-4 col-md-3 col-lg-2">
        <a href="https://savannahga.gov" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
          <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/city-of-savannah.png" alt="city of savannah logo">
        </a>
      </div>

      <!-- 2. BIG -->
      <div class="col-6 col-sm-4 col-md-3 col-lg-2">
        <a href="https://research.georgiasouthern.edu/big" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
          <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/business-innovation-group.jpg" alt="georgia southern business innovation group logo">
        </a>
      </div>

      <!-- 3. Howmet Aerospace -->
      <div class="col-6 col-sm-4 col-md-3 col-lg-2">
        <a href="https://www.howmet.com/foundation" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
          <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/howmet-aerospace.png" alt="howmet aerospace logo">
        </a>
      </div>
        
      <!-- 4. Howmet Women's Network -->
      <div class="col-6 col-sm-4 col-md-3 col-lg-2">
        <a href="https://www.howmet.com/diversity-equity-inclusion" target="_blank" class="sponsor-card d-flex align-items-center justify-content-center p-3 rounded-3">
          <img class="img-fluid sponsor-logo-img" src="assets/sponsor-logos/howmet-womens-network.png" alt="howmet women's network logo">
        </a>
      </div>

    </div>
  </div>
  <!-- *************** END: Winter Camp 2023 Sponsors ************ -->

</div>      

<!-- **************************************** END: WINTER CAMP 2023 *********************************************** -->
<!-- ************************************************************************************************************** -->

    `
  }
}


// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('wc2023-feature', WC2023Feature);
